import { render, staticRenderFns } from "./ProductsUpsertModal.vue?vue&type=template&id=3947b906"
import script from "./ProductsUpsertModal.vue?vue&type=script&lang=js"
export * from "./ProductsUpsertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports